var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-like-row table-b"},[_c('base-container',{attrs:{"vertical-center":""}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }